import React, { useState } from 'react';
import styles from './LinkedAccounts.module.scss';
import Button from 'component/atom/forms/button/Button';
import AccountCard from './account-card/AccountCard';
import Modal from 'component/hoc/modal/Modal';
import Select from 'component/atom/forms/select/select/Select';
import Input from 'component/atom/forms/input/input/Input';

const LinkedAccounts = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles['main']}>
      <div className={styles['title-container']}>
        <div className={styles['title']}>
          <p className={styles['title-text']}>Linked Accounts</p>
          <p className={styles['title-desc']}>
            Connect multiple accounts from different systems to this user
          </p>
        </div>
        <Button
          label='Link Account'
          type='plus'
          onClick={() => setIsOpen(true)}
        />
      </div>
      <div className={styles['accounts-container']}>
        <AccountCard />
        <AccountCard />
        <AccountCard />
        <AccountCard />
        <AccountCard />
      </div>
      <Modal
        title='Link Accounts'
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        buttonType='submit'
        modalContent={{
          component: (
            <div className={styles['modal-container']}>
              <Select
                label='System'
                options={[
                  { label: 'Microsoft', value: 1 },
                  { label: 'Google', value: 2 },
                ]}
                placeholder='Select System'
              />
              <Input label='Email Address' placeholder='Enter Email Address' />
            </div>
          ),
        }}
        onSubmitstyles={{
          onSubmit: {
            label: 'Save',
            type: 'save',
            opicBAckground: true,
          },
        }}
      />
    </div>
  );
};

export default LinkedAccounts;
